"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vouchers_1 = require("../../economy/vouchers");
const payment_plans_1 = require("../../economy/payment-plans");
const map = {
    is: {
        currently: 'no',
    },
    mentionContent: {
        reminderFeeRow: 'Rykkergebyr, jf. renteloven § 9b, annet ledd',
        debtCollectionFeeRow: 'Inkassogebyr, jf. renteloven § 9b, første ledd',
        debtCollectionCostRow: 'Inkassoomkostninger, jf. renteloven § 9a, første ledd',
        compensationFeeRow: 'Kompensasjonsgebyr, jf. renteloven § 9a, tredje ledd',
        fixedInterestRow: 'Tidligere påløpte renter',
        processInterestRow: 'Påløpte renter fra forfallsdato',
        yearlyInterestRow: 'Påløpte renter',
        otherCosts: 'Andre kostnader',
        sum: 'Totalt utestående',
        paid: 'Allerede betalt',
        invoice: 'Faktura',
        date: 'Dato',
        dueDate: 'Forfallsdato',
        amount: 'Beløp',
        email: 'E-post',
        phone: 'Telefon',
        signature: 'Signatur',
        journalNumber: 'Journalnummer',
        genericEmailSubjectPre: 'Angående din gjeld til',
        genericEmailSubjectForAlternativeContactPre: 'Sak hos',
        satisfactionsOrClick: 'eller klikk',
        satisfactionsHere: 'her',
        principalReferenceIdsAnd: ' og ',
    },
    debtorWebPaymentPlans: {
        backToCase: 'Tilbake til sak',
        paymentPlanOn: 'Betalingsplan på sak',
        selectPlan: 'Velg betalingsplan',
        sign: 'Signer avtale',
        gatherInfo: 'Legg inn informasjon',
        paymentMethod: 'Velg betalingsmetode',
        approval: 'Bekreftelse',
        info: 'Info',
        paymentPlan: 'Betalingsplan',
        firstPayment: 'Første betaling',
        entry: 'oppføring',
        lastPayment: 'Siste betaling',
        signedDoc: 'Signert dokument',
        needHelp: 'Trenger hjelp?',
        orPay: 'Eller betal hele gjelden',
        pay: 'Betal hele gjelden',
        months: 'Måneder',
        month: 'måned',
        total: 'Total betaling',
        select: 'Velg',
        noOptions: 'Dessverre er det ikke mulig å sette opp en betalingsplan.',
        signTextOne: 'For å melde deg på en betalingsplan med',
        signTextThree: 'Før du kan signere avtalen, må du fylle ut informasjonen din.',
        signTextTwoAlternativeContact: 'må debitor signere følgende avtale.',
        signTextTwoDebtor: 'må du signere følgende avtale.',
        agreement: 'Signer avtale',
        approvalText: 'Gratulerer. Du har inngått en betalingsplan.',
        paymentMethodText: 'Vi tar vare på kortinformasjonen din og gjør det enkelt for deg å melde deg på automatisk betaling.',
        connectCard: 'Koble til betalingsmetode',
        automaticPaymentMethod: 'Automatisk betalingsmetode',
        deleteCardToChange: 'Du kan endre/slette det valgte kortet ved å klikke på slett-kort-knappen.',
        deleteCard: 'Slett kort',
        paymentPlanEntries: 'Betalingsplanoppføringer',
        amount: 'Beløp',
        date: 'Dato',
        status: 'Status',
        statusCode: {
            [payment_plans_1.PaymentPlanEntryStatus.SETTLED]: 'Betalt',
            [payment_plans_1.PaymentPlanEntryStatus.CANCELED]: 'Standard',
            [payment_plans_1.PaymentPlanEntryStatus.PENDING]: 'Fremtidig',
            [payment_plans_1.PaymentPlanEntryStatus.REMINDED]: 'Påminnet',
            [payment_plans_1.PaymentPlanEntryStatus.AWAITING]: 'Avventer',
            [payment_plans_1.PaymentPlanEntryStatus.OVERDUE]: 'Forfalt',
            [payment_plans_1.PaymentPlanEntryStatus.ERRORSETTLED]: 'Mislykket korttrekning',
        },
    },
    emailSignature: {
        privacyPolicyText: 'Behandling av data. Vi kan behandle personopplysninger om deg. Du kan lese personvernerklæringen vår her:',
        regards: 'Med vennlig hilsen',
    },
    pluralEconomyVoucherTypeLabels: {
        [vouchers_1.VoucherTypeIds.PRINCIPAL]: 'Hovedstol',
        [vouchers_1.VoucherTypeIds.INVOICE]: 'Fakturaer',
        [vouchers_1.VoucherTypeIds.ONACCOUNTINVOICE]: 'Fakturaer på konto',
        [vouchers_1.VoucherTypeIds.DOM]: 'Dom',
        [vouchers_1.VoucherTypeIds.FINALINVOICE]: 'Avsluttende oppgjør',
        [vouchers_1.VoucherTypeIds.CONTROLFEE]: 'Kontrollgebyrer',
        [vouchers_1.VoucherTypeIds.ADMINISTRATIONCOST]: 'Administrasjonskostnader',
        [vouchers_1.VoucherTypeIds.CREDITNOTE]: 'Kreditnotaer',
        [vouchers_1.VoucherTypeIds.YEARLYINTEREST]: 'Årlige renter',
        [vouchers_1.VoucherTypeIds.PROCESSINTEREST]: 'Renter',
        [vouchers_1.VoucherTypeIds.GLPROCESSINTEREST]: 'Renter (GL)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Sammensatt rente (daglig rentetilskrivning)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Sammensatt rente (månedlig rentetilskrivning)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Sammensatt rente (kvartalsvis rentetilskrivning)',
        [vouchers_1.VoucherTypeIds.REMINDERFEE]: 'Purringssatser',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOST]: 'Inkassokostnader',
        [vouchers_1.VoucherTypeIds.COLLECTIONFEE]: 'Inkassogebær',
        [vouchers_1.VoucherTypeIds.BAILIFFSFEE]: 'Fogedgebyrer',
        [vouchers_1.VoucherTypeIds.WRITFEE]: 'Rettssak-gebyr',
        [vouchers_1.VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Sakskostnader uten sivil rett',
        [vouchers_1.VoucherTypeIds.COURTCLAIMSALARY]: 'Lønn ved rettskrav',
        [vouchers_1.VoucherTypeIds.BAILIFSSALARY]: 'Lønn for foged',
        [vouchers_1.VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Fogedrekvisitionsgebyrer',
        [vouchers_1.VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Gebyr for politipresentasjon',
        [vouchers_1.VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Sakskostnader med fogedrett',
        [vouchers_1.VoucherTypeIds.WRITSALARY]: 'Lønn for rettssaker',
        [vouchers_1.VoucherTypeIds.COMPENSATIONCOST]: 'Kompensasjonskostnader',
        [vouchers_1.VoucherTypeIds.Folkeregisteropslag]: 'Folkeregisteroppslag',
        [vouchers_1.VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Immaterielle rettssaker',
        [vouchers_1.VoucherTypeIds.CIVILCOURTCOST]: 'Kostnader for sivil rett',
        [vouchers_1.VoucherTypeIds.DEPOSIT]: 'Innskudd',
        [vouchers_1.VoucherTypeIds.WITHDRAWAL]: 'Uttak',
        [vouchers_1.VoucherTypeIds.OVERPAYMENT]: 'Overbetalinger',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSION]: 'Inkassokommisjoner',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Inkassokommisjoner (overvåking)',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Inkassokommisjoner (kundedepositum)',
        [vouchers_1.VoucherTypeIds.JURIDISKBISTAND]: 'Juridisk bistand',
        [vouchers_1.VoucherTypeIds.ENDCASEFEE]: 'Avslutningsgebyr',
        [vouchers_1.VoucherTypeIds.STARTCASEFEE]: 'Oppstartgebyr',
        [vouchers_1.VoucherTypeIds.BPKFEE]: 'BPK-gebyrer',
        [vouchers_1.VoucherTypeIds.FOGEDFEE]: 'Fogedgebyrer',
        [vouchers_1.VoucherTypeIds.RKIREGISTRATIONFEE]: 'RKI-registreringsgebyrer',
        [vouchers_1.VoucherTypeIds.BPKDISBURSEMENT]: 'Utløsningsgebyrer',
        [vouchers_1.VoucherTypeIds.POLICEDISBURSEMENT]: 'Politidisbursements',
        [vouchers_1.VoucherTypeIds.FOGEDDISBURSEMENT]: 'Fogedrekvisisjon',
        [vouchers_1.VoucherTypeIds.VAT]: 'MVA',
        [vouchers_1.VoucherTypeIds.GAELDSBREV]: 'Lån',
        [vouchers_1.VoucherTypeIds.SETTLEMENT]: 'Forlik',
        [vouchers_1.VoucherTypeIds.FIXEDINTEREST]: 'Fast rente',
        [vouchers_1.VoucherTypeIds.UDTRAEKSGEBYR]: 'Udtræksgebyrer',
        [vouchers_1.VoucherTypeIds.DEPOSITPAYOUT]: 'Utbetalinger av depositum',
        [vouchers_1.VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Folkeregisteropslag',
        [vouchers_1.VoucherTypeIds.ANMELDELSEAFKRAV]: 'Anmeldelse af krav',
        [vouchers_1.VoucherTypeIds.MeetingFee]: 'Møtegebyrer',
        [vouchers_1.VoucherTypeIds.STAEVNINGSGEBYR]: 'Stævningsgebyr',
        [vouchers_1.VoucherTypeIds.BERAMMELSESAFGIFT]: 'Berammelsesgebyr',
        [vouchers_1.VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Aflysning af udlæg',
        [vouchers_1.VoucherTypeIds.LOCKSMITHFEE]: 'Låsesmedgebyr',
        [vouchers_1.VoucherTypeIds.DRIVINGFEE]: 'Kjørekostnader',
        [vouchers_1.VoucherTypeIds.OTHERFEE]: 'Andre kostnader',
        [vouchers_1.VoucherTypeIds.REFUND]: 'Refusjon',
    },
    economyVoucherTypeLabels: {
        [vouchers_1.VoucherTypeIds.PRINCIPAL]: 'Hovedstoler',
        [vouchers_1.VoucherTypeIds.INVOICE]: 'Faktura',
        [vouchers_1.VoucherTypeIds.ONACCOUNTINVOICE]: 'Faktura med kredit',
        [vouchers_1.VoucherTypeIds.DOM]: 'Dom',
        [vouchers_1.VoucherTypeIds.FINALINVOICE]: 'Endelig oppgjør',
        [vouchers_1.VoucherTypeIds.CONTROLFEE]: 'Kontrollgebyr',
        [vouchers_1.VoucherTypeIds.ADMINISTRATIONCOST]: 'Administrasjonskostnad',
        [vouchers_1.VoucherTypeIds.CREDITNOTE]: 'Kreditnota',
        [vouchers_1.VoucherTypeIds.YEARLYINTEREST]: 'Årlig rente',
        [vouchers_1.VoucherTypeIds.PROCESSINTEREST]: 'Rente',
        [vouchers_1.VoucherTypeIds.GLPROCESSINTEREST]: 'Rente (GL)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Sammensatt rente (daglig rentetilskrivning)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Sammensatt rente (månedlig rentetilskrivning)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Sammensatt rente (kvartalsvis rentetilskrivning)',
        [vouchers_1.VoucherTypeIds.REMINDERFEE]: 'Purringssgebyr',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOST]: 'Innkrevingskostnad',
        [vouchers_1.VoucherTypeIds.COLLECTIONFEE]: 'Innkrevingsgebyr',
        [vouchers_1.VoucherTypeIds.COMPENSATIONCOST]: 'Erstatningskostnad',
        [vouchers_1.VoucherTypeIds.Folkeregisteropslag]: 'Folkeregisteroppslag',
        [vouchers_1.VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Saker om immaterielle rettigheter',
        [vouchers_1.VoucherTypeIds.DEPOSIT]: 'Innskudd',
        [vouchers_1.VoucherTypeIds.WITHDRAWAL]: 'Uttak',
        [vouchers_1.VoucherTypeIds.OVERPAYMENT]: 'Overbetaling',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSION]: 'Innkrevingsprovisjon',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Innkrevingsprovisjon (overvåkning)',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Innkrevingsprovisjon (kreditorinnskudd)',
        [vouchers_1.VoucherTypeIds.JURIDISKBISTAND]: 'Juridisk bistand',
        [vouchers_1.VoucherTypeIds.ENDCASEFEE]: 'Avgift ved avslutning av sak',
        [vouchers_1.VoucherTypeIds.STARTCASEFEE]: 'Avgift ved start av sak',
        [vouchers_1.VoucherTypeIds.BPKFEE]: 'BPK-avgift',
        [vouchers_1.VoucherTypeIds.FOGEDFEE]: 'Fogedrekvisisjonsgebyr',
        [vouchers_1.VoucherTypeIds.RKIREGISTRATIONFEE]: 'RKI-registreringsgebyr',
        [vouchers_1.VoucherTypeIds.BPKDISBURSEMENT]: 'Utlegg for skriftlig begjæring',
        [vouchers_1.VoucherTypeIds.POLICEDISBURSEMENT]: 'Utlegg for politiframlegg',
        [vouchers_1.VoucherTypeIds.FOGEDDISBURSEMENT]: 'Utlegg for fogedrekvisisjon',
        [vouchers_1.VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Sakskostnader uten sivilt rettslig krav',
        [vouchers_1.VoucherTypeIds.COURTCLAIMSALARY]: 'Saksgebyr',
        [vouchers_1.VoucherTypeIds.VAT]: 'MVA',
        [vouchers_1.VoucherTypeIds.BAILIFFSFEE]: 'Fogedgebyr',
        [vouchers_1.VoucherTypeIds.BAILIFSSALARY]: 'Fogedlønn',
        [vouchers_1.VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Gebyr for politiframlegg',
        [vouchers_1.VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Sakskostnader med fogedrett',
        [vouchers_1.VoucherTypeIds.CIVILCOURTCOST]: 'Sivile rettskostnader',
        [vouchers_1.VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Gebyr for fogedrekvisisjon',
        [vouchers_1.VoucherTypeIds.WRITFEE]: 'Gebyr for skriftlig begjæring',
        [vouchers_1.VoucherTypeIds.WRITSALARY]: 'Lønn for skriftlig begjæring',
        [vouchers_1.VoucherTypeIds.GAELDSBREV]: 'Lån',
        [vouchers_1.VoucherTypeIds.SETTLEMENT]: 'Forlik',
        [vouchers_1.VoucherTypeIds.FIXEDINTEREST]: 'Fast rente',
        [vouchers_1.VoucherTypeIds.UDTRAEKSGEBYR]: 'Uttaksgebyr',
        [vouchers_1.VoucherTypeIds.DEPOSITPAYOUT]: 'Utbetaling av innskudd',
        [vouchers_1.VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Folkeregisteroppslag',
        [vouchers_1.VoucherTypeIds.ANMELDELSEAFKRAV]: 'Anmeldelse av krav',
        [vouchers_1.VoucherTypeIds.MeetingFee]: 'Møtegebyr',
        [vouchers_1.VoucherTypeIds.STAEVNINGSGEBYR]: 'Gebyr for stevning',
        [vouchers_1.VoucherTypeIds.BERAMMELSESAFGIFT]: 'Gebyr for beramming',
        [vouchers_1.VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Aflysning af udlæg',
        [vouchers_1.VoucherTypeIds.LOCKSMITHFEE]: 'Låsesmedgebyr',
        [vouchers_1.VoucherTypeIds.DRIVINGFEE]: 'Kjøregodtgjørelse',
        [vouchers_1.VoucherTypeIds.OTHERFEE]: 'Andre gebyrer',
        [vouchers_1.VoucherTypeIds.REFUND]: 'Refusjon',
    },
};
exports.default = map;
//# sourceMappingURL=no.js.map